import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { JobOpeningsVo } from 'src/app/models/jobOpenings';
import { CommonService } from 'src/app/service/common.service';
import { MessageService } from 'src/app/service/messageService';
import { WebService } from 'src/app/service/web.service';

@Component({
  selector: 'app-job-openings',
  templateUrl: './job-openings.component.html',
  styleUrls: ['./job-openings.component.scss']
})
export class JobOpeningsComponent implements OnInit {

  constructor(
    private route: Router,
    public commonService : CommonService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private webService : WebService,
    private msgService: MessageService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (params: Params) => (this.jobId = params["id"])
    );
    if(this.commonService.validateTextId(this.jobId)) {
      this.getJobDetails(this.jobId);
    }

    this.getCategoryTypes();
    this.getDomainTypes();
    this.getTagList();
    this.getlocationList();
    this.getemployerList();
  }

  jobDetail: JobOpeningsVo = new JobOpeningsVo();
  jobId: any;

  selectedCategory: any;
  selectedLocation: any;
  selectedDomain: any;
  selectedEmployer: any;
  refId: any;
  contact: any;
  selectedTagIds: any = [];
  link: any;
  yrsOfExp: any;
  refEmail: any;
  skills: any;
  applyUrl: any;
  isContact: any = false;
  jobDescription: any;
  description: any;

  // For Tags
  selectable: boolean = true;
  removable: boolean = true;
  selectedTags: any[] = [];

  validCategory: boolean = true;
  validDomain: boolean = true;
  validDesc: boolean = true;
  validContact: boolean = true;
  validLocation: boolean = true;
  validEmployer: boolean = true;

  // categoryTypes: any[] = [{name:'Full Time', identity: '1'}, {name:'Contract', identity: '2'}];
  // domainTypes: any[] = [{name:'Infra', identity: '1'}, {name:'DevOps', identity: '2'}, {name:'Cloud', identity: '3'}, {name:'ADM', identity: '4'}, {name:'Containers', identity: '5'}, {name:'Others', identity: '6'}];
  // locationList: any[] = [{name:'Chennai', identity: '1'}, {name:'Bangalore', identity: '2'}];
  // employerList: any[] = [{name:'TCS', identity: '1'}, {name:'CTS', identity: '2'}];
  tagList: any[] = [];
  // tagListOrg: any[] = [{name:'Angular', identity: '1'}, {name:'Java', identity: '2'}, {name:'Spring Boot', identity: '3'}, {name:'Typescript', identity: '4'}, {name:'AWS', identity: '5'}, {name:'Lambda', identity: '6'}, {name:'Node', identity: '7'}];





  categoryTypes: any[] = [];
  tagListOrg: any[] = [];
  domainTypes: any[] = [];
  locationList: any[] = [];
  employerList: any[] = [];
  getCategoryTypes(){
    this.webService.getOptionListByGroup("Job-Catergory").subscribe((data:any)=>{
      this.categoryTypes =  data;
    })    
  }

  
  getDomainTypes(){
    this.webService.getOptionListByGroup("Job-Domain").subscribe((data:any)=>{
      this.domainTypes =  data;
    })    
  }
  
  
  getTagList(){
    this.webService.getOptionListByGroup("Tags").subscribe((data:any)=>{
      this.tagListOrg= data;
      this.tagList.push(...this.tagListOrg);
    })    
  }

  getlocationList(){
    this.webService.getOptionListByGroup("Job-Location").subscribe((data:any)=>{
      this.locationList =  data;
    })    
  }
  
  
  getemployerList(){
    this.webService.getOptionListByGroup("Job-Employer").subscribe((data:any)=>{
      this.employerList= data;
    })    
  }


  getJobDetails(questId: any) {
    this.getJob(questId).subscribe(data => {
       let responce : any = data;
        this.jobDetail = responce.body.Item;
        this.setQuestDetails();
    });
  }

  setQuestDetails() {
    this.selectedCategory = this.jobDetail.category;
    this.selectedDomain = this.jobDetail.domain;
    this.description = this.jobDetail.description;
    this.link = this.jobDetail.link;
    this.selectedTagIds = this.jobDetail.tags;
    this.jobDescription = this.jobDetail.jobDescriptions;
    this.refId = this.jobDetail.jobRefference_ID;
    this.selectedEmployer = this.jobDetail.employer;
    this.selectedLocation = this.jobDetail.location;
    this.refEmail = this.jobDetail.referranceEmailID;
    this.skills = this.jobDetail.skills;
    this.applyUrl = this.jobDetail.applyUrl;
    
    this.yrsOfExp = this.jobDetail.minMaxYrsOfExp;
    
    this.isContact = this.jobDetail.allowToContact;
    
    this.contact = this.jobDetail.contentDetails;
    
    setTimeout(()=>{                       
      this.setTagsForExisting();
  }, 1000);

  }

  getJob(questId:any) {
    // TODO: Add Url here
    return this.http.get("https://2g4zhd7wfzofwhiiqhxkggu5fq0bpsqo.lambda-url.us-west-1.on.aws?param1=" + questId);
  }

  selectCategory(event: any): any {
    this.selectedCategory = event;
    this.validCategory = true;
  }

  selectDomain(event: any):any {
    this.selectedDomain = event;
    this.validDomain = true;
  }

  valiDateLocation(event: any): any {
    if(this.commonService.validateText(this.selectedLocation)) {
      this.validLocation = true;
      return;
    }
    this.validLocation = false;
  }

  valiDateEmployer(event: any): any {
    if(this.commonService.validateText(this.selectedEmployer)) {
      this.validEmployer = true;
      return;
    }
    this.validEmployer = false;
  }

  setContact(value: any) {
    this.isContact = value;
    this.validContact = true;
  }

  validateDesc(event: any) {
    if(this.commonService.validateText(this.description)) {
      this.validDesc = true;
      return;
    }
    this.validDesc = false;
  }

  tagSelected(event: any, dmain: any, input: any): void {
    if(!event || !event.isUserInput) {
      return;
    }
    if(!this.commonService.validateList(this.selectedTags)) {
      this.selectedTags = [];
    }
    if(!this.commonService.validateList(this.selectedTagIds)) {
      this.selectedTagIds = [];
    }
    let isAlreadyAdded: boolean = false;
    if (this.selectedTags.length != 0) {
      for (let index = 0; index < this.selectedTags.length; index++) {
        if (dmain.identity == this.selectedTags[index].identity) {
          isAlreadyAdded = true;
        }
      }

      if (!isAlreadyAdded) {
        this.selectedTags.push(dmain);
        this.selectedTagIds.push(dmain.name);
      }
    } else {
      this.selectedTags.push(dmain);
      this.selectedTagIds.push(dmain.name);
    }
    this.tagList = [];
    this.tagList.push(...this.tagListOrg);
    input.value = '';
  }

  remove(dmain: any): void {
    let isExist: boolean = false;
    let removeIndex = 0;
    if (this.selectedTags.length != 0) {
      for (let index = 0; index < this.selectedTags.length; index++) {
        if (dmain.identity == this.selectedTags[index].identity) {
          isExist = true;
          removeIndex = index;
          this.selectedTagIds.splice(this.selectedTagIds.indexOf(dmain.name), 1);
          break;
        }
      }
      
      if(isExist) {
        this.selectedTags.splice(removeIndex, 1);
      }
    }
  }

  searchTag(event: any, input: any): any {
    if (this.commonService.preventKeyUp(event)) {
      let selctedTagValue = input.value;
      if(!this.commonService.validateText(selctedTagValue)) {
        this.tagList = [];
        this.tagList.push(...this.tagListOrg);
        return;
      }
      this.tagList = this.tagList.filter( val => val.name.toLowerCase().includes(selctedTagValue.toLowerCase()));
    }
  }

  setTagsForExisting() {
    if(this.selectedTagIds != undefined && this.selectedTagIds != [] && this.selectedTagIds.length > 0) {
      this.selectedTags = [];
      for (let j = 0; j < this.selectedTagIds.length; j++) {
        for (let i = 0; i < this.tagList.length; i++) {
          if(this.selectedTagIds[j] == this.tagList[i].name){
            this.selectedTags.push(this.tagList[i]);
          }
        }
      }
    }
  }

  cancelJob() {
    // TODO: need to add url
    this.route.navigateByUrl('/jobOpenings');
  }

  saveJob() {
    if(!this.validateMandatoryFields()) {
      // TODO: need to show toastr error message
      return;
    }
    this.buildjobDetail();
    // TODO: need to add url

    if (this.jobDetail.description != undefined && this.jobDetail.description != null && this.jobDetail.description != ""){
      let wordCount = this.jobDetail.description ? this.jobDetail.description.split(/\s+/) : 0;
  
        if(wordCount.length > 20){
          this.msgService.error("Description should be less than 20 words")
        return;
  
        }
      }

      if (this.jobDetail.jobDescriptions != undefined && this.jobDetail.jobDescriptions != null && this.jobDetail.jobDescriptions != ""){
        let wordCount = this.jobDetail.jobDescriptions ? this.jobDetail.jobDescriptions.split(/\s+/) : 0;
    
          if(wordCount.length > 250){
            this.msgService.error("Content Detail should be less than 250 words")
          return;
    
          }
        }

        if(localStorage.getItem("userId")!= undefined) {
          this.jobDetail.userId = localStorage.getItem("userId");
        }



    // if (this.jobDetail.link != undefined && this.jobDetail.link != null && this.jobDetail.link != ""){
    //   this.http.get('http://api.linkpreview.net/?key=accd5245417245de6140169b9d5ff688&q='+this.jobDetail.link).subscribe((data: any)=>{
    //        console.log(data);
     
    //        let metadata:any = {};
    //         metadata.description = data.description;
    //         metadata.image = data.image;
    //         metadata.title = data.title;
    //         metadata.url = data.url;
     
     
    //        this.jobDetail.linkMetaData = metadata;
    //        this.saveJobOpenCallTrigger();
    //      })
    //      } else {
           this.saveJobOpenCallTrigger();
        //  }
   
  }

  saveJobOpenCallTrigger() {

    let body :any = {};
    body = this.jobDetail;
    this.http.post<any>('https://n55xr6sdj6uze7nwmsy3e746lq0kanwx.lambda-url.us-west-1.on.aws/',  body).subscribe(data => {
      let responce : any = data;
      this.route.navigateByUrl('/jobOpenings');
    })
  }

  validateMandatoryFields(): boolean {
    let isValid: boolean = true;
    if(!this.commonService.validateText(this.selectedCategory)) {
      this.validCategory = false;
      isValid = false;
    }

    if(!this.commonService.validateText(this.selectedDomain)) {
      this.validDomain = false;
      isValid = false;
    }

    if(!this.commonService.validateText(this.description)) {
      this.validDesc = false;
      isValid = false;
    }

    if(!this.commonService.validateText(this.selectedEmployer)) {
      this.validEmployer = false;
      isValid = false;
    }

    if(!this.commonService.validateText(this.selectedLocation)) {
      this.validLocation = false;
      isValid = false;
    }

    if(this.selectedCategory === undefined || this.selectedCategory === null) {
      this.validContact = false;
      isValid = false;
    }

    if(isValid) {
      this.validCategory = true;
      this.validDomain = true;
      this.validDesc = true;
      this.validContact = true;
      this.validEmployer = true;
      this.validLocation = true;
    }
    return isValid;
  }

  buildjobDetail() {
    this.jobDetail.category = this.selectedCategory;
    this.jobDetail.domain = this.selectedDomain;
    this.jobDetail.description = this.description;
    this.jobDetail.link = this.link;
    this.jobDetail.tags = this.selectedTagIds;
    this.jobDetail.allowToContact = this.isContact;
    this.jobDetail.jobDescriptions = this.jobDescription;
    this.jobDetail.jobRefference_ID = this.refId;
    this.jobDetail.location = this.selectedLocation;
    this.jobDetail.minMaxYrsOfExp = this.yrsOfExp;
    this.jobDetail.referranceEmailID = this.refEmail;
    this.jobDetail.skills = this.skills;
    this.jobDetail.applyUrl = this.applyUrl;
    this.jobDetail.employer = this.selectedEmployer;
    this.jobDetail.contentDetails = this.contact;
  }

}
